import React from 'react';
import cx from 'classnames';
import { ConnectToXero, DisconnectFromXero } from '../../assets/xero';
import style from './XeroButton.module.scss';

const XeroButton = ({ isConnect, loading, disabled, className, ...rest }) => {
  const altText = isConnect ? 'Connect to Xero' : 'Disconnect from Xero';
  const baseClassName = isConnect ? style.connectToXero : style.disconnectFromXero;
  return (
    <button
      className={cx(baseClassName, loading && style.loading, className)}
      disabled={disabled || loading}
      {...rest}
    >
      <img src={isConnect ? ConnectToXero : DisconnectFromXero} alt={altText} />
    </button>
  );
};

const ConnectToXeroButton = ({ ...rest }) => <XeroButton isConnect={true} {...rest} />;
const DisconnectFromXeroButton = ({ ...rest }) => <XeroButton isConnect={false} {...rest} />;

export { ConnectToXeroButton, DisconnectFromXeroButton };
